import { AnyFieldApi } from '@tanstack/react-form'
import map from 'lodash/map'
import React, { useId } from 'react'

import { Checkbox } from '@Components/FormElements/UI/Checkbox'
import { GiftCardAmountOption } from '@Domains/Product/Features/GiftCard/Hooks'

import styles from './GiftCard.module.scss'

/**
 * The gift card amount radio-list, bound to a TanStack form field holding the
 * selected option key. `children` render below the rows (e.g. the custom-amount
 * input when its option is selected).
 */
export const GiftCardAmountOptionList = ({
  children,
  field,
  options,
}: {
  children?: React.ReactNode
  field: AnyFieldApi
  options: GiftCardAmountOption[]
}) => {
  const id = useId()

  return (
    <div className={styles.optionList}>
      {map(options, option => (
        <button
          key={`GiftCard_${option.key}`}
          className={styles.option}
          onClick={() => field.handleChange(option.key)}
          type="button"
        >
          <Checkbox
            aria-label={option.key}
            checked={field.state.value === option.key}
            id={`giftCardAmountOption-${id}-${option.key}`}
            label={option.value}
            title={option.value}
          />
        </button>
      ))}
      {children}
    </div>
  )
}
